import tw from 'twin.macro';
import React, { TextareaHTMLAttributes } from 'react';
import { css } from '@emotion/react';

export interface TextareaProps extends TextareaHTMLAttributes<HTMLTextAreaElement> {
  className?: string;
  autoGrow?: boolean;
  enterBreakLine?: boolean;
  ref?: any;
}

const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ value, className, children, autoGrow, enterBreakLine = true, onKeyDown, ...props }, ref) => {
    const textareaRef = React.useRef<HTMLTextAreaElement>(null);
    const handleAutoGrow = (element: HTMLTextAreaElement): void => {
      if (!autoGrow) {
        return;
      }
      element.style.height = '5px';
      element.style.height = element.scrollHeight + 2.5 + 'px';
    };

    React.useEffect(() => {
      textareaRef.current && handleAutoGrow(textareaRef.current);
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [value]);

    return (
      <textarea
        ref={ref ? ref : textareaRef}
        css={[
          tw`
            border-color-input-box 
            rounded-input          
            appearance-none
            block
            border
            w-full
            p-3
            text-gray-0
            leading-tight
            focus:outline-none`,
          css`
            &::placeholder {
              opacity: 1;
              ${tw`text-color-input-placeholder`}
            }
            &:disabled {
              opacity: 0.45;
            }
          `,
        ]}
        className={className}
        value={value || ''}
        onKeyDown={(e): void => {
          !enterBreakLine && e.keyCode === 13 && e.preventDefault();
          onKeyDown && onKeyDown(e);
        }}
        {...props}
      >
        {children}
      </textarea>
    );
  }
);

export default Textarea;
